import React, { FC } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';

import { Grid, Row, Col } from '../../ui/Grid';
import Alert from '../../ui/Alert';
import { ANALYSES_META_INFO, DEEPSEA_ANALYSES } from '../../../settings';
import Tooltip from '../../ui/Tooltip';
import s from './DeepSEAJobSubmitPage.css';
import DeepSEAJobManager from './DeepSEAJobManager';

interface DeepSEAJobSubmitPageProps {
  analysis?: string;
  modelName?: string | null;
}

const DeepSEAJobSubmitPage: FC<DeepSEAJobSubmitPageProps> = ({
  analysis = DEEPSEA_ANALYSES.deepsea,
  modelName = null,
}) => {
  // analysis comes from a query string and the default above only fills in for
  // undefined, so '' and unknown values reach the lookups. Resolve once and pass
  // it down -- every child indexes ANALYSES_META_INFO, and a miss during SSR is
  // a 500. Check DEEPSEA_ANALYSES: that map also covers networks and seek.
  const resolvedAnalysis = Object.values(DEEPSEA_ANALYSES).includes(analysis)
    ? analysis
    : DEEPSEA_ANALYSES.deepsea;
  const analysisMetaInfo = ANALYSES_META_INFO[resolvedAnalysis];

  return (
    <div className={s.root}>
      <Grid>
        <Row>
          <Col md={12}>
            <h2>
              {analysisMetaInfo.name} analysis
              <br />
              <small>{analysisMetaInfo.textOverview}</small>
            </h2>
            <hr />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {analysisMetaInfo.defaultModelName === 'sei' && (
              <Alert bsStyle="warning">
                <strong>New sequence model</strong>
                <br />
                <p>
                  Sei provides a global map from any sequence to regulatory
                  activities, as represented by 40 sequence classes by
                  integrating predictions for 21,907 chromatin profiles. You can
                  also find the Sei code repository{' '}
                  <a href="https://github.com/FunctionLab/sei-framework">
                    here
                  </a>{' '}
                  or read about our manuscript{' '}
                  <a href="https://www.biorxiv.org/content/10.1101/2021.07.29.454384v1">
                    here
                  </a>
                  . See{' '}
                  <Tooltip
                    id="helpLink"
                    text={`Help for ${analysisMetaInfo.name}`}
                    url={analysisMetaInfo.helpUrl}
                  />
                  for more details.
                </p>
              </Alert>
            )}
            <div style={{ padding: '15px' }}>
              <DeepSEAJobManager
                analysis={resolvedAnalysis}
                modelName={modelName}
              />
            </div>
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

export default withStyles(s)(DeepSEAJobSubmitPage);
